// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    IconChartArcs,
    IconClipboardList,
    IconChartInfographic,
    IconHomeDot,
    IconUser,
    IconBox,
    IconUserCircle,
    IconBuilding,
    IconBrain
} from '@tabler/icons';

import SettingsIcon from "@mui/icons-material/Settings";
// constant
const icons = {
    IconChartArcs,
    IconClipboardList,
    IconChartInfographic,
    IconHomeDot,
    IconUser,
    IconBox
};




// ==============================|| WIDGET MENU ITEMS ||============================== //

const adminBusiness = {
    id: 'dash-admin',
    title: <FormattedMessage id="dash-admin" />,
    icon: icons.IconChartArcs,
    type: 'group',
    children: [
        {
            id: "staff-group",
            title: <FormattedMessage id="staff" />,
            type: "collapse",
            icon: IconUserCircle,
            children: [
                {
                    id: "staff",
                    title: <FormattedMessage id="staff" />,
                    type: "item",
                    icon: IconUserCircle,
                    url: "/dashboard/staff",
                },
                {
                    id: "departments",
                    title: <FormattedMessage id="departments" />,
                    type: "item",
                    icon: IconBuilding,
                    url: "/dashboard/departments",
                },
                {
                    id: "skills",
                    title: <FormattedMessage id="skills" />,
                    type: "item",
                    icon: IconBrain,
                    url: "/dashboard/skills",
                },
            ],
        },
        {
            id: 'mybusiness',
            title: <FormattedMessage id="mybusiness" />,
            type: 'item',
            url: '/dashboard/my-business',
            icon: SettingsIcon
        },
    ]
};

export default adminBusiness;
